import React, {useContext, useState} from 'react';
import './OrderComment.less';
import {Input} from 'elements/input/Input';
import {Button} from "elements/button/Button";
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const ORDER_COMMENT_POPUP = 'ORDER_COMMENT_POPUP';

export const OrderComment = ({defaultValue = '', maxLength = 160, onCancelClick, onDoneClick}) => {
	const [comment, setComment] = useState(defaultValue);

	const translations = useContext(TranslationsContext);

	return <DrawerPopup
		title={`${getSafeTranslation('OrderCommentPopup.title', translations)} (${comment.length}/${maxLength})`}
		leftControl={<Button isText onClick={onCancelClick}>{
			getSafeTranslation('OrderCommentPopup.cancelButtonCaption', translations)
		}</Button>}
		rightControl={<Button isText onClick={() => onDoneClick(comment)}>{
			getSafeTranslation('OrderCommentPopup.doneButtonCaption', translations)
		}</Button>}
	>
		<div className="order-comment">
			<Input
				isMultiline
				value={comment}
				onChange={(newComment) => {
					if (newComment.length <= maxLength) {
						setComment(newComment)
					}
				}}
				focusOnMount
			/>
		</div>
	</DrawerPopup>
}
